import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik';
import { TextField, Select } from 'formik-material-ui';
import { Grid, InputLabel, MenuItem, FormControl, FormHelperText } from '@material-ui/core';
import useStyles from '../Support-form.style';

const BaseFormComponent = ({ config, errors = {} }) => {
    const classes = useStyles();
    return (
        <>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    required
                    id="fName"
                    name="fName"
                    label={config.form.fName.label}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    required
                    id="lName"
                    name="lName"
                    label={config.form.lName.label}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    id="nickname"
                    name="nickname"
                    label={config.form.nickname.label}
                    fullWidth
                />

            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    id="phoneNumber"
                    name="phoneNumber"
                    label={config.form.phoneNumber.label}
                    type="number"
                    fullWidth
                />

            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    required
                    id="email"
                    name="email"
                    label={config.form.email.label}
                    type="email"
                    style={{ textAlign: 'end', direction: 'ltr' }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    component={TextField}
                    required
                    id="emailVerification"
                    name="emailVerification"
                    label={config.form.emailVerification.label}
                    type="email"
                    style={{ textAlign: 'start', direction: 'ltr' }}
                    fullWidth />

            </Grid>
            <Grid item xs={12}>
                <FormControl className={classes.formControl} error={'subject' in errors} fullWidth>
                    <InputLabel htmlFor="subject">{config.form.subject.label}</InputLabel>
                    <Field
                        id="subject"
                        component={Select}
                        required
                        name="subject"
                        inputProps={{
                            id: 'subject',
                        }}>
                        {config.form.subject.options.map(item => (
                            <MenuItem key={item.text} value={item.value}>{item.text}</MenuItem>
                        ))}
                    </Field>
                    {
                        'subject' in errors ? <FormHelperText>This filed is required.</FormHelperText> : null
                    }
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <Field
                    component={TextField}
                    required
                    multiline
                    rows={12}
                    id="message"
                    name="message"
                    label={config.form.message.label}
                    fullWidth />
            </Grid>
        </>
    )
}

BaseFormComponent.propTypes = {
    config: PropTypes.object,
    errors: PropTypes.object
}

export default BaseFormComponent;